import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=224fb268&"
import script from "./CTA.vue?vue&type=script&lang=js&"
export * from "./CTA.vue?vue&type=script&lang=js&"
import style0 from "./CTA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports